<template>
  <div>
    <menu-bar></menu-bar>
    <el-container style="width: 100%;margin: 0 auto">
      <el-main>
        <el-col :span="13" style="width: 50.5%;margin-left: 1%">
          <el-tabs v-model="activeCurTab" type="border-card" @tab-click="changeActiveCurTab">
            <el-tab-pane label="汰换排行榜" name="Ranking"></el-tab-pane>
            <el-tab-pane :label="$t('Form Market')" name="Market"></el-tab-pane>
          </el-tabs>
          <el-card
            v-if="activeCurTab == 'Market'"
            :body-style="{padding: '0px'}"
            v-loading="loading"
            element-loading-text="try connecting to Csgo2"
          >
            <div slot="header" class="cardHeader"
                 style="display: flex;justify-content: space-between;align-items: center">
              <div>
                <div style="display: flex;height: 32px;align-items: center">
                  <el-autocomplete
                    style="width: 382px"
                    size="small"
                    :trigger-on-focus="false"
                    v-model="filterForm.name"
                    :fetch-suggestions="remoteMethod"
                    :placeholder="$t('pleaseInput')"
                    @keydown.native="onKeyDown"
                  ></el-autocomplete>
                  <el-select v-model="filterForm.weaponCases" multiple :placeholder="$t('WeaponCase')"
                             size="small"
                             clearable filterable collapse-tags style="width: 225px;margin-left: 8px">
                    <el-option
                      style="font-size: 12px"
                      v-for="item in weaponCasesOptions"
                      :key="item.optionKey"
                      :label="formatterLocalOption(item)"
                      :value="item.optionKey">
                    </el-option>
                  </el-select>
                  <el-button style="margin-left: 8px;" type="primary" size="small" @click="loadingMarketData">
                    搜索
                  </el-button>
                  <el-button type="warning" style="margin-left: 8px" size="small"
                             @click="clearMarketOptions">重置
                  </el-button>

                </div>
                <div>
                  <el-select style="width: 125px" size="small" filterable clearable
                             :placeholder="$t('Exterior')"
                             v-model="filterForm.wearType">
                    <el-option
                      v-for="item in wearTypeOptions"
                      :key="item.optionKey"
                      :label="$t(item.optionKey)"
                      :value="item.optionKey"
                    >
                      <div :style="item.optionColor"
                           style="margin-right: 8px;display: inline;color: white;padding: 2px;min-width: 4px">
                      </div>
                      <div style="display: inline">
                        {{ $t(item.optionKey) }}
                      </div>
                    </el-option>
                  </el-select>
                  <el-select style="width: 125px" size="small" filterable clearable
                             :placeholder="$t('Rarity')"
                             v-model="filterForm.rarity">
                    <el-option
                      v-for="item in tradeUpRarityOptions"
                      :key="item.rarity"
                      :value="item.rarity"
                      :label="formatterLocalRarityName(item)"
                    >
                      <span :style="`color:${item.color};font-size:12px`">
                        {{ formatterLocalRarityName(item) }}
                      </span>
                    </el-option>
                  </el-select>
                  <el-select style="width: 125px" size="small" filterable clearable v-model="filterForm.quality">
                    <el-option :key="0" :value="0" :label="$t('Normal')"></el-option>
                    <el-option :key="2" :value="2" label="StatTrak™"></el-option>
                  </el-select>
                  <el-select style="width: 125px" size="small" filterable clearable v-model="filterForm.orderBy">
                    <el-option key="priceAsc" value="priceAsc" label="价格升序"></el-option>
                    <el-option key="priceDesc" value="priceDesc" label="价格降序"></el-option>
                    <el-option key="paintWearAsc" value="paintWearAsc" label="磨损升序"></el-option>
                    <el-option key="paintWearDesc" value="paintWearDesc" label="磨损降序"></el-option>
                  </el-select>
                </div>
              </div>
              <div style="display: flex" v-show="activeCurTab==='inventory'">
                <div class="user_inv_info">
                  <div id="voi">共: {{ searchForm.total == undefined ? 0 : searchForm.total }} 件物品</div>
                  <div id="nt">可交易物品: {{ searchForm.tradeAbleCount == undefined ? 0 : searchForm.tradeAbleCount }}
                    件
                  </div>
                  <div id="voi1">估值: {{
                      searchForm.totalPrice == null || searchForm.totalPrice == undefined ? '' : searchForm.totalPrice.toFixed(2)
                    }} ￥
                  </div>
                </div>
              </div>

            </div>
            <div class="block_content">
              <div class="item_container" style="text-align: center">
                <div v-for="(inventoryItem,index) of inventories" style="display: inline-block;height: 225px">
                  <inventory-item :inventory-item="inventoryItem"
                                  :weapon-cases-index="weaponCasesIndex"
                                  @click.native="changeCheckBox(inventoryItem)"
                                  style="cursor: pointer;width: 165px"
                  ></inventory-item>
                </div>
              </div>
            </div>
          </el-card>
          <el-card
            v-if="activeCurTab == 'Ranking'"
            :body-style="{padding: '0px'}"
            v-loading="rankingLoading"
            element-loading-text="Loading....."
          >
            <div class="block_content">
              <el-table :data="rankingList" border style="width: 100%;font-size: 13px;" :header-cell-style="{background: '#f8f8f8'}">
                <el-table-column label="排名" width="60px" align="center">
                  <template #default="scope">
                    <span :style="rankStyle(scope.$index)">{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="配方名称" prop="name" min-width="220px">
                  <template #default="scope">
                    <span style="display: inline-block;width: 100%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ scope.row.templateName }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="costs" label="成本" width="85px" align="right" sortable>
                  <template #default="scope">￥{{ scope.row.costs }}</template>
                </el-table-column>
                <el-table-column prop="profitRate" label="回报率" width="85px" align="right" sortable>
                  <template #default="scope">
                    <span :style="{'color': scope.row.income - scope.row.costs >= 0 ? '#48bb78' : '#f56c6c'}">
                      {{ scope.row.profitRate }} %
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="breakEvenRate" label="保本率" width="85px" align="center" sortable>
                  <template #default="scope">{{ scope.row.breakEvenRate }}%</template>
                </el-table-column>
                <el-table-column label="操作" width="80px" align="center">
                  <template #default="scope">
                    <el-button size="mini" @click="loadItems(scope.row)">加载</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
        <el-col :span="11" style="margin-left: 12px">
          <el-card :body-style="{padding: '0px'}">
            <div slot="header" class="cardHeader">
              <div style="padding: 0 8px;display: flex;align-items: center;justify-content: space-between">
                <div>
                  {{ $t('Trade Up Calculator') }}
                </div>

                <div style="display: flex;height: 32px">
                  <el-button size="small" plain @click="clearSelectedData">{{ $t('Reset') }}</el-button>
                </div>
              </div>
              <div
                class="el-alert el-alert--info is-light"
                style="padding: 0 12px;font-size: 13px;margin: 0;-webkit-box-sizing: border-box;box-sizing: border-box;border-radius: 4px;position: relative;overflow: hidden;opacity: 1;background-color: #f4f4f5;color: #909399;">
                <div style="display: flex;justify-content: space-between;width: 100%">
                  <div>
                    保本率:  {{ simulateResult.breakEvenRate == undefined ? '':(simulateResult.breakEvenRate * 100).toFixed(2) + '%' }}
                  </div>

                  <div>
                    <span style="margin-right: 12px">
                       {{ '预计成本 ' + calculateSelectedDataValue }}
                    </span>
                    <span>
                      期望: {{ calculateOutputDataValue }}
                    </span>

                  </div>
                </div>

              </div>
            </div>
            <div>
              <div class="item_container" style="display: inline-block">
                <el-collapse  v-model="activeResultCollapse">
                  <el-collapse-item >
                    <template slot="title" >
                      <div style="margin-left: 12px">
                          <span v-for="arr of groupWeaponCases" style="margin-right: 12px">
                          {{arr[0].weaponCase}} {{arr.length}} 个
                        </span>
                      </div>

                    </template>
                    <div style="text-align: center">
                      <div v-for="inventoryItem of selectedData" class="item">
                        <div class="item-floating-details">
                          <div class="item-floating-details__body">
                            <div class="item-floating-details__main">
                              <div class="item-floating-details__top">
                                <div class="base-tooltip">
                                  <div class="base-tooltip__activator tooltip-activator">
                                    <div :style="inventoryItem.isFake ? 'opacity: .3;':''">
                                      <div class="item-floating-730-label item-floating-details__label"
                                           style="height: 24px">
                                      <span class="item-floating-730-label__small">
                                        <div style="display: flex">
                                          <div
                                            style="z-index: 999;flex: 1;white-space: nowrap;text-overflow: ellipsis;overflow: hidden">
                                            {{
                                              formatterLocalName(inventoryItem)
                                            }}
                                          </div>
                                        </div>
                                      </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <img :alt="inventoryItem.engName"
                                   data-type="SMG"
                                   :src="inventoryItem.icon_url"
                                   :style="inventoryItem.isFake ? 'opacity: .3;':''"
                                   class="item-floating-details__image">
                              <div style="position: absolute;bottom: 105px;">
                                <el-tag size="small" type="info" :style="formatterWear(inventoryItem)"
                                        style="opacity: 0.9">
                                  {{ $t(regexWear(inventoryItem.engName)) }}
                                </el-tag>
                              </div>
                              <div class="item-details-row-light" style="height: 20px;margin-bottom: 8px;">
                              <span class="item-details-row__label">
<!--                                <el-tag type="info" size="small">￥{{-->
<!--                                    inventoryItem.minPrice == null ? '' : inventoryItem.minPrice.toFixed(2)-->
<!--                                  }}</el-tag>-->
                                <el-input style="width: 75px;font-size: 11px" v-model="inventoryItem.minPrice" size="mini"></el-input>
                              </span>
                                <span class="item-details-row__value">
                                <el-tag v-if="inventoryItem.rarityName" size="small" type="info"
                                        style="float: right;max-width: 85px;"
                                        :style="formatterRarity(inventoryItem.rarityName)">
                                  {{ formatterLocalRarityName(inventoryItem) }}
                                </el-tag>
                              </span>
                              </div>
                              <div v-if="inventoryItem.paint_wear" class="item-float item-card__float"
                                   :style="`--float-value:${inventoryItem.paint_wear * 100}%`"
                                   style="--float-background-color: #56524d;--float-range-start: 0%; --float-range-end: 100%;">
                                <div data-v-2cf355cb="" class="item-float__bar"></div>
                                <svg data-v-2cf355cb="" height="13" viewBox="0 0 20 13" width="20"
                                     class="item-float__indicator">
                                  <path data-v-2cf355cb=""
                                        d="M4.5 7.115V2a2 2 0 012-2h7a2 2 0 012 2v5.115a2 2 0 01-.655 1.48L10 13 5.155 8.595a2 2 0 01-.655-1.48z"></path>
                                </svg>
                              </div>
                              <div v-else style="height: 29px"></div>
                              <div class="item-details-row-light" v-if="inventoryItem.paint_wear"
                                   style="  margin-bottom: 4px;">
                                <el-input type="input" v-model="inventoryItem.paint_wear" size="mini"
                                          style="font-size: 11px;"
                                          @blur="changePaintWear(inventoryItem)"></el-input>
                              </div>
                              <div
                                style="height: 28px;font-size: 12px;align-items: center;justify-content: space-between;">
                                <div style="display: flex;width: 100%;justify-content: space-between">
                                  <el-button size="mini" @click="copySelectedData(inventoryItem)"
                                             style="margin-left: 0px;color: #E6A23C">
                                    {{ $t('Copy') }}
                                  </el-button>
                                  <el-button size="mini" style="color:#F56C6C;margin-left: 0px"
                                             @click="removeSelectedData(inventoryItem)">
                                    {{ $t('Delete') }}
                                  </el-button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style="text-align: center;font-size: 12px;margin-top: 8px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;height: 16px">
                          {{ formatterLocalWeaponCaseName(inventoryItem.weaponCase) }}
                        </div>
                      </div>
                    </div>

                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </el-card>
          <el-card :body-style="{padding: '0px'}" style="margin-top: 12px">
            <div slot="header" class="cardHeader">
              <div style="padding: 0 8px">
                {{ $t('Trade Up Result') }}
              </div>
            </div>
            <div>
              <el-collapse v-show="!simulateLoading" v-model="activeResultCollapse">
                <el-collapse-item :title="weaponCase" :name="weaponCase" :key="weaponCase"
                                  v-for="(arr,weaponCase) of groupResultWeaponCases">
                  <template slot="title">
                    <div style="padding: 0 12px;display: flex;justify-content: space-between;width: 100%">
                      <div>
                        {{weaponCase}}
                        {{
                          (groupResultWeaponCases[weaponCase].reduce((sum, obj) => (sum += obj.percentage), 0) * 100).toFixed(2)
                        }}
                        %
                      </div>
                    </div>
                  </template>
                  <div class="item_container">
                    <div v-for="inventoryItem of groupResultWeaponCases[weaponCase]"
                         style="display: inline-block;width: 165px">
                      <div class="item-floating-details">
                        <div class="item-floating-details__body">
                          <div class="item-floating-details__main">
                            <div class="item-floating-details__top">
                              <div class="base-tooltip">
                                <div class="base-tooltip__activator tooltip-activator">
                                  <div>
                                    <div class="item-floating-730-label item-floating-details__label">
                                      <span class="item-floating-730-label__small">
                                        <div style="display: flex">
                                          <div
                                            style="z-index: 999;flex: 1;white-space: nowrap;text-overflow: ellipsis;overflow: hidden">
                                            {{
                                              formatterLocalName(inventoryItem)
                                            }}
                                          </div>
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <img :alt="inventoryItem.engName"
                                 data-type="SMG"
                                 :src="inventoryItem.icon_url"
                                 class="item-floating-details__image">
                            <div style="position: absolute;bottom: 74px;">
                              <el-tag size="small" type="info" :style="formatterWear(inventoryItem)"
                                      style="opacity: 0.9">
                                {{ $t(regexWear(inventoryItem.engName)) }}
                              </el-tag>
                            </div>
                            <div class="item-details-row-light"
                                 style="height: 20px;margin-bottom: 8px;align-items: center;display: flex">
                              <span class="item-details-row__label">
<!--                                <el-tag type="info" size="small">￥{{-->
<!--                                    inventoryItem.minPrice == null ? '' : inventoryItem.minPrice.toFixed(2)-->
<!--                                  }}-->
<!--                                </el-tag>-->
                                   <el-input style="width: 75px;font-size: 11px" v-model="inventoryItem.minPrice" size="mini"></el-input>
                              </span>
                              <span class="item-details-row__value">
                                <el-tag size="small" type="info"
                                        style="float: right;max-width: 85px;">
                                  {{
                                    (inventoryItem.percentage * 100).toFixed(2)
                                  }} %
                                </el-tag>
                              </span>
                            </div>
                            <div v-if="inventoryItem.paint_wear" class="item-float item-card__float"
                                 :style="`--float-value:${inventoryItem.paint_wear * 100}%`"
                                 style="--float-background-color: #56524d;--float-range-start: 0%; --float-range-end: 100%;">
                              <div data-v-2cf355cb="" class="item-float__bar"></div>
                              <svg data-v-2cf355cb="" height="13" viewBox="0 0 20 13" width="20"
                                   class="item-float__indicator">
                                <path data-v-2cf355cb=""
                                      d="M4.5 7.115V2a2 2 0 012-2h7a2 2 0 012 2v5.115a2 2 0 01-.655 1.48L10 13 5.155 8.595a2 2 0 01-.655-1.48z"></path>
                              </svg>
                            </div>
                            <div v-else style="height: 29px"></div>
                            <div class="item-details-row-light" v-if="inventoryItem.paint_wear">
                              <span class="item-details-row__label" style="width: 30%">{{ $t('paint_wear') }}</span>
                              <span class="item-details-row__value">{{ inventoryItem.paint_wear.toFixed(11) }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
              <el-skeleton style="padding: 24px" v-if="simulateLoading" :rows="6" animated/>
            </div>
          </el-card>
        </el-col>
      </el-main>
    </el-container>

    <el-dialog
      center
      custom-class="tradeUpTemplate"
      title="保存配方"
      :visible.sync="tradeUpTemplateModal"
      width="25%">
      <div>
        <el-form ref="tradeUpTemplateForm" :rules="rules" :model="tradeUpTemplateForm" label-width="110px"
                 labelPosition="top">
          <el-form-item label="配方名称" required>
            <el-input v-model="tradeUpTemplateForm.name"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="tradeUpLoading" @click="handleSaveTradeUpTemplate">确 定</el-button>
        <el-button @click="tradeUpTemplateModal = false">取 消</el-button>
      </span>
    </el-dialog>

    <login-dialog ref="loginDialog"></login-dialog>
  </div>
</template>

<script>
import {
  allTradeUpTemplates,
  craft,
  getUserInventory,
  queryPaintWearPrice, remoteSearchOptions, saveSimulateTradeUpTemplate,
  simulateRemoteOptions,
  simulateTradeUp
} from "../../api/api";
import MenuBar from "../Menu/menuBar";
import InventoryItem from './item'
import {
  tradeUpRarityOptions,
  wearTypeOptions,
  rarityLevelMapper,
  cloneObj,
  formatterRarity, rartiyIndex, formatterWear, regexWear, getRefreshToken,
} from "../../api/util";
import {mixins} from "../../mixin";
import LoginDialog from "../Login/index.vue";
import {isEmpty} from "../../api/util";

export default {
  name: "inventory",
  components: {LoginDialog, InventoryItem, MenuBar},
  mixins: [mixins],
  data() {
    return {
      // 排行榜相关数据
      rankingList: [],
      rankingLoading: false,
      rankingSort: 'incomeDesc',
      rankingTimeFilter: 'all',
      rankingDetailModal: false,
      currentRanking: {},
      activeTab: this.$route.query.appId,
      searchForm: {
        limit: 200,
        tradeAbleCount: 0,
        totalPrice: 0,
        total: 0
      },
      filterForm: {
        wearType: '',
        rarity: '',
        orderBy: 'priceAsc',
        quality: 0, // 类别 normal:0  stat:1
        weaponCases: []
      },
      activeCurTab: 'Ranking',
      inventories: [],
      backupInventories: [],
      loading: false,
      sellingData: [],
      selectedData: [],
      tradeUpRarityOptions: tradeUpRarityOptions,
      wearTypeOptions: wearTypeOptions,
      activeCollapse: [],
      simulateData: [],
      simulateResult: {},
      simulateLoading: false,
      activeResultCollapse: [],
      toAddSimulateItem: '',
      remoteOptions: [],
      tradeUpTemplateModal: false,
      tradeUpTemplateForm: {
        limit: 10,
        offset: 1,
        total: 0,
        name: ''
      },
      rules: {},
      tradeUpLoading: false
    }
  },
  watch: {
    selectedData: {
      handler(arr) {
        // 取第一个rarity
        let rarity = this.selectedData[0].rarity

        // 如果没有展开的 则默认展开第一个
        if (this.activeCollapse.length === 0) {
          let hasActive = false
          for (let item of arr) {
            if (this.activeCollapse.indexOf(item.weaponCase) !== -1) {
              hasActive = true
              break;
            }
          }
          if (!hasActive && arr.length > 0) {
            this.activeCollapse = arr[0].weaponCase
          }
        }

        let minCount = 10
        if (rarity == 6){
          minCount = 5
        }
        if (arr.length === minCount) {
          this.simulateLoading = true
          simulateTradeUp({
            data: this.groupWeaponCases,
            quality: this.selectedData[0].quality === 4 ? 0 : 2,
            rarity: rarityLevelMapper[this.selectedData[0].rarity]
          }).then(json => {
            this.simulateData = json.data.data.rows
            this.simulateResult = json.data.data
          }).finally(_ => {
            this.simulateLoading = false
          })
        } else {
          this.simulateData = []
          this.simulateResult = {}
        }
      }
    },
  },
  computed: {
    calculateSelectedDataValue() {
      let value = 0
      for (let item of this.selectedData) {
        let price = item.minPrice || 0
        value += Number(price)
      }
      return value.toFixed(2)
    },
    calculateOutputDataValue(){
      if (this.simulateData.length == 0){
        return 0
      }else{
        let value = 0
        for (let item of this.simulateData){
          let price = item.minPrice || 0
          value += item.percentage * Number(price)
        }
        return value.toFixed(2)
      }
    },
    groupWeaponCases() {
      let groupDic = {}
      for (let item of this.selectedData) {
        let weaponCase = item.weaponCase
        let arr
        if (groupDic[weaponCase] === null || groupDic[weaponCase] === undefined) {
          arr = []
        } else {
          arr = groupDic[weaponCase]
        }
        arr.push(item)
        groupDic[weaponCase] = arr
      }
      return groupDic
    },
    groupResultWeaponCases() {
      let groupDic = {}
      for (let item of this.simulateData) {
        let weaponCase = item.weaponCase
        let arr
        if (groupDic[weaponCase] === null || groupDic[weaponCase] === undefined) {
          arr = []
        } else {
          arr = groupDic[weaponCase]
        }
        arr.push(item)
        groupDic[weaponCase] = arr
      }
      return groupDic
    }
  },
  methods: {
    loadItems(row){
      let weaponData = JSON.parse(row.content)
      const weaponList = [];
      const dataObj = weaponData.data;

      // 遍历 data 下的所有键（兼容 data 下有多个武器箱子的情况）
      Object.keys(dataObj).forEach(key => {
        const currentWeapons = dataObj[key];
        // 确保当前键对应的值是数组，再合并到结果中
        if (Array.isArray(currentWeapons)) {
          weaponList.push(...currentWeapons);
        }
      });

      this.selectedData = weaponList
    },
    // 排名样式（前三名高亮）
    rankStyle(index) {
      if (index === 0) return 'color: #ffd700; font-weight: bold;'
      if (index === 1) return 'color: #c0c0c0; font-weight: bold;'
      if (index === 2) return 'color: #cd7f32; font-weight: bold;'
      return 'color: #666;'
    },
    checkRefreshToken() {
      let refreshToken = getRefreshToken()
      if (refreshToken == null || refreshToken == undefined) {
        this.$refs.loginDialog.loginDialog = true
        return
      } else {
        this.doSearch(730)
      }
    },
    handleSaveTradeUpTemplate() {
      this.$refs['tradeUpTemplateForm'].validate((valid) => {
        if (valid) {
          this.tradeUpLoading = true
          saveSimulateTradeUpTemplate({
            data: this.groupWeaponCases,
            quality: this.selectedData[0].quality === 4 ? 0 : 2,
            rarity: rarityLevelMapper[this.selectedData[0].rarity],
            name: this.tradeUpTemplateForm.name
          }).then(json => {
            if (json.data.flag === 'T') {
              this.$message.info("保存成功,等待审核")
              this.tradeUpTemplateModal = false
            }
          }).catch(e => {
            this.$message.error(e.response.data.message)
          }).finally(_ => {
            this.tradeUpLoading = false
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    removeSelectedData(item) {
      let index = this.selectedData.indexOf(item)
      this.selectedData.splice(index, 1)
      if (this.activeCurTab === 'Inventory') {
        this.inventories.unshift(item)
        this.applyFilter()
      }
    },
    copySelectedData(item) {
      let maxCount = 10
      let rarity = this.selectedData[0].rarity
      if (rarity == 6){
        maxCount = 5
      }
      if (this.selectedData.length < maxCount) {
        let copyData = cloneObj(item)
        copyData.isFake = true
        this.selectedData.push(copyData)
      } else {
        this.$message({
          message: '汰换物品个数超过上限',
          type: 'warning'
        });
      }
    },
    executeTradeUp() {
      let items = []
      let recipe;
      if (this.selectedData.length != 0) {
        recipe = this.recipeMapper(this.selectedData[0])
      }
      for (let item of this.selectedData) {
        if (item.isFake) {
          this.$message.error("模拟配方无法汰换")
          return
        }
        items.push(item.id)
      }
      let data = {
        items: items,
        recipe: recipe
      }
      craft(data).then(json => {
        this.$message({
          type: 'success',
          message: '汰换成功'
        })
        // 重置刷新
        this.clearSelectedData()
        this.doSearch(this.activeTab)
      })
    },
    saveTradeUpTemplate() {
      // 跳出modal添加名字
      if (!this.checkHasLogin()) {
        return
      }
      if (this.selectedData.length === 10) {
        this.tradeUpTemplateModal = true
      } else {
        this.$message.error("请先选择10个物品进行汰换")
        return
      }
    },
    // 0 = Trade-Up: 10x Consumer Grade → 1x Industrial Grade
    // 1 = Trade-Up: 10x Industrial Grade → 1x Mil-Spec Grade
    // 2 = Trade-Up: 10x Mil-Spec Grade → 1x Restricted
    // 3 = Trade-Up: 10x Restricted → 1x Classified
    // 4 = Trade-Up: 10x Classified → 1x Covert
    // 10 = Trade-Up: 10x StatTrak Consumer Grade → 1x StatTrak Industrial Grade
    // 11 = Trade-Up: 10x StatTrak Industrial Grade → 1x StatTrak Mil-Spec Grade
    // 12 = Trade-Up: 10x StatTrak Mil-Spec Grade → 1x StatTrak Restricted
    // 13 = Trade-Up: 10x StatTrak Restricted → 1x StatTrak Classified
    // 14 = Trade-Up: 10x StatTrak Classified → 1x StatTrak Covert
    recipeMapper(item) {
      let recipe = item.rarity - 1
      if (item.quality === 9) {
        recipe += 10
      }
      return recipe
    },
    checkCanAdd(data) {
      // 校验quality / rarity 是否一致
      if (this.selectedData.length === 0) {
        return true
      }
      let maxCount = 10
      let rarity = this.selectedData[0].rarity
      if (rarity == 6){
        maxCount = 5
      }
      if (this.selectedData.length < maxCount) {
        for (let item of this.selectedData) {
          if (item.rarity !== data.rarity) {
            this.$message.error(this.$t('Wrong Rarity'));
            return false
          }
          if (item.quality !== data.quality) {
            this.$message.error(this.$t('Wrong Quality'));
            return false
          }
        }
        return true
      } else {
        this.$message({
          message: '汰换物品个数超过上限',
          type: 'warning'
        });
        return false
      }
    },
    clearSelectedData() {
      this.toAddSimulateItem = ''
      this.remoteOptions = {}
      this.selectedData = []
      this.simulateData = []
      this.filterForm = {
        wearType: '',
        rarity: '',
        orderBy: 'priceAsc',
        quality: 0, // 类别 normal:0  stat:1
        weaponCases: []
      }
    },
    routerToHistory() {
      // 校验是否rt登录
      let refreshToken = getRefreshToken()
      if (refreshToken == null || refreshToken == undefined) {
        this.$message.error(this.$t('Login Required'));
        return
      } else {
        this.$router.push('/TradeUpHistory')
      }
    },
    formatterRarity(val) {
      return formatterRarity(val)
    },
    formatterWear(inventoryItem) {
      let wearArr = inventoryItem.engName.match(/\(([^)]*)\)/)
      if (wearArr != null && wearArr !== undefined && wearArr.length > 1) {
        return formatterWear(wearArr[1])
      } else {
        return ''
      }
    },
    formatterLocalWeaponCaseName(val) {
      return val
    },
    regexWear(engName) {
      return regexWear(engName)
    },
    formatterLocalName(item) {
      let lang = localStorage.getItem("selectedLanguage")
      if (lang === 'zh') {
        return item.cnName
      } else {
        return item.engName
      }
    },
    totalPaintWear(arr) {
      try {
        let paintWear = 0
        for (let item of arr) {
          paintWear += parseFloat(item.paint_wear)
        }
        return paintWear.toFixed(5)
      } catch (e) {
        return ''
      }
    },
    clearMarketOptions() {
      this.simulateData = []
      this.filterForm = {
        name:'',
        wearType: '',
        rarity: '',
        orderBy: 'priceAsc',
        quality: 0, // 类别 normal:0  stat:1
        weaponCases: []
      }
      this.loadingMarketData()
    },
    applyFilter() {
      if (this.activeCurTab === 'Market') {
        return
      } else {
        let arr = []
        let tempDic = {}
        let tempArr = cloneObj(this.backupInventories)
        for (let item of tempArr) {
          tempDic[item.id] = item
        }

        // 去掉selectedData
        for (let item of this.selectedData) {
          delete tempDic[item.id]
        }
        let handleArr = []
        for (let k in tempDic) {
          handleArr.push(tempDic[k])
        }

        for (let inventoryItem of handleArr) {
          let rarityFilter = !isEmpty(this.filterForm.rarity) ? false : true
          if (rarityLevelMapper[inventoryItem.rarity] == this.filterForm.rarity && inventoryItem.paint_wear) {
            rarityFilter = true
          }

          let wearTypeFilter = !isEmpty(this.filterForm.wearType) ? false : true
          if (inventoryItem.engName.indexOf(this.filterForm.wearType) !== -1) {
            wearTypeFilter = true
          }

          let weaponCaseFilter = this.filterForm.weaponCases.length !== 0 ? false : true
          if (this.filterForm.weaponCases.indexOf(inventoryItem.weaponCase) !== -1) {
            weaponCaseFilter = true
          }

          let qualityFilter = !isEmpty(this.filterForm.quality) ? false : true
          if ((this.filterForm.quality === 0 && inventoryItem.quality === 4) || (this.filterForm.quality === 2 && inventoryItem.quality === 9)) {
            qualityFilter = true
          }

          if (rarityFilter && wearTypeFilter && weaponCaseFilter && qualityFilter) {
            arr.push(inventoryItem)
          }
        }
        if (!isEmpty(this.filterForm.orderBy)) {
          switch (this.filterForm.orderBy) {
            case "priceAsc":
              arr.sort(function (a, b) {
                return a.minPrice - b.minPrice;
              });
              break;
            case "priceDesc":
              arr.sort(function (a, b) {
                return b.minPrice - a.minPrice;
              });
              break;
            case "paintWearAsc":
              arr.sort(function (a, b) {
                return a.paint_wear - b.paint_wear;
              });
              break;
            case "paintWearDesc":
              arr.sort(function (a, b) {
                return b.paint_wear - a.paint_wear;
              });
              break;
          }
        }
        this.inventories = arr
      }
    },
    remoteMethod(val, cb) {
      remoteSearchOptions({name: val, game: 'csgo',tradeUp:true}).then(json => {
        for (let option of json.data) {
          option.value = option.cnName
        }
        cb(json.data)
      })
    },
    onKeyDown($event) {
      if ($event.keyCode == 13) {
        this.loadingMarketData()
      }
    },
    formatterLocalOption(item) {
      let lang = localStorage.getItem("selectedLanguage")
      if (lang === 'zh') {
        return item.optionValue
      } else {
        return item.optionKey
      }
    },
    changePaintWear(item) {
      // 请求后端查询价格信息
      item.isFake = true
      let rarity = this.selectedData[0].rarity
      let maxCount = 10
      if (rarity == 6){
        maxCount = 5
      }
      queryPaintWearPrice(
        {
          engName: item.engName,
          paint_wear: item.paint_wear,
          quality: item.quality === 4 ? 0 : 1
        }).then(json => {
        if (json.data.flag === 'T') {
          let priceInfo = json.data.data
          this.$set(item, 'minPrice', priceInfo.minPrice)
          this.$set(item, 'engName', priceInfo.engName)
          this.$set(item, 'cnName', priceInfo.cnName)

          if (this.selectedData.length === maxCount) {
            this.simulateLoading = true
            simulateTradeUp({
              data: this.groupWeaponCases,
              quality: this.selectedData[0].quality === 4 ? 0 : 1,
              rarity: rarityLevelMapper[this.selectedData[0].rarity]
            }).then(json => {
              this.simulateData = json.data.data.rows
              this.simulateResult = json.data.data
            }).finally(_ => {
              this.simulateLoading = false
            })
          }
        }
      })
    },
    formatterLocalRarityName(item) {
      let lang = localStorage.getItem("selectedLanguage")
      if (lang === 'zh') {
        return item.rarityName
      } else {
        return rartiyIndex[item.rarity]
      }
    },
    changeActiveCurTab(val) {
      if (val.name === 'Inventory') {
        this.doSearch(this.activeTab)
      } else if (val.name === 'Market') {
        this.loadingMarketData()
      } else if (val.name === 'Ranking'){
        this.loadRankingList()
      }
    },
    loadingMarketData() {
      // 刷新市场数据
      this.backupInventories = []
      this.inventories = []
      this.loading = true
      if (this.filterForm.orderBy === 'disCountAsc') {
        this.filterForm.orderBy = ''
      }
      simulateRemoteOptions(this.filterForm).then(json => {
        this.backupInventories = json.data.data
        this.inventories = cloneObj(json.data.data)
      }).finally(_ => {
        this.loading = false
      })
    },
    loadRankingList() {
      allTradeUpTemplates().then(json => {
        this.rankingList = json.data.data.sort((a, b) => {
          // 按 profitRate 从高到低排序，后项减前项实现降序
          return b.profitRate - a.profitRate;
        });
      });
    },
    changeCheckBox(inventoryItem) {
      // 纪念品无法添加
      console.log(inventoryItem)
      if (inventoryItem.quality === 12 || (inventoryItem.canTradeUp == null || !inventoryItem.canTradeUp)) {
        this.$message.error("无法汰换")
        return
      }

      if (this.selectedData.length === 0 && inventoryItem.paint_wear) {
        this.filterForm.rarity = rarityLevelMapper[inventoryItem.rarity]
        this.filterForm.quality = inventoryItem.quality === 4 ? 0 : 2

        this.applyFilter()
      }

      if (inventoryItem.paint_wear) {
        if (this.checkCanAdd(inventoryItem)) {
          let data = cloneObj(inventoryItem)
          this.selectedData.push(data)
          if (this.activeCurTab === 'Inventory') {
            let arr = []
            for (let item of this.inventories) {
              if (item.id !== inventoryItem.id) {
                arr.push(item)
              }
            }
            this.inventories = arr
          }
        }
      }
    },
    addTradeItem(item) {
      console.log(item)
    },
    checkTradable(dateTimeString) {
      // 创建一个新的Date对象，传入给定的日期时间字符串
      var inputDate = new Date(dateTimeString);

      // 获取当前时间
      var currentDate = new Date();

      // 比较当前时间和给定的日期时间
      if (currentDate > inputDate || dateTimeString == null) {
        // 当前时间晚于给定的日期时间
        return false;
      } else {
        // 当前时间不晚于给定的日期时间
        return true;
      }
    },
    async doSearch(appId) {
      let vm = this
      this.loading = true
      getUserInventory({appId: appId}).then(json => {
        let total = 0
        let totalPrice = 0
        let tradableCount = 0
        for (let item of json.data.data) {
          item.isFake = false
          totalPrice += item.minPrice
          if (this.checkTradable(item)) {
            tradableCount++;
          }
          total++;
        }
        vm.$set(vm, 'inventories', json.data.data)
        vm.$set(vm, 'backupInventories', cloneObj(json.data.data))
        vm.searchForm.total = total
        vm.searchForm.tradeAbleCount = tradableCount
        vm.searchForm.totalPrice = totalPrice
      }).catch(e => {
        vm.$message.error(e.response.data.message);
      }).finally(_ => {
        vm.loading = false
      })
      // this.inventories = mockInventories
      // this.backupInventories = mockInventories
    },
  },
  created() {
    // 上报跳转到库存的事件
    this.$gtag.event('TradeUp', {})

    if (isEmpty(this.$route.query.appId)) {
      this.activeTab = 730
    } else {
      this.activeTab = this.$route.query.appId
    }
    this.loadRankingList()
  },
}
</script>

<style scoped>
.block_content {
  box-sizing: border-box;
  flex: 1;
  height: 600px;
  overflow-x: hidden;
  overflow-y: auto;
  user-select: none;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  will-change: transform;
}

.item_container {
  gap: 8px;
  display: flex;
  position: relative;
  flex-wrap: wrap;
  justify-content: center;
  margin: auto;
  text-align: left;
  -webkit-appearance: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  width: 100%;
  height: 100%;
  will-change: scroll-position, transform;
}

.header-menu {
  position: relative;
  height: 70px;
  border-bottom: 1px solid #dcdfe6;
}

.header-menu h1 {
  margin: 0;
  float: left;
  position: absolute;
  font-size: 26px;
  top: 12px;
  color: #409EFF;
  left: 7%;
  font-weight: 400;
}

.user_inv_info {
  line-height: 1.2;
  font-family: Courier New;
  font-size: 12px;
  text-align: left;
  padding-right: 10px;
  margin-left: 20px;
  min-width: 135px;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/deep/ .cardHeader {
  line-height: 44px;
}

.el-card /deep/ .el-card__header {
  padding: 8px 12px;
}

.item{
  display: inline-block;
  width: 180px;
}

.item-floating-details__body {
  background: whitesmoke;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, .1), 0 2px 4px -1px rgba(0, 0, 0, .06);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 6px 8px;
}

.item-details-box {
  background-color: #302e2a;
  border-radius: 0.25rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .05);
  font-size: .75rem;
  padding: 1rem;
  height: 100px;
}

.item-details-row__label {
  color: #aea89b;
  width: 65%;
}

.item-details-row__value {
  flex: 1;
  text-align: center;
}

.item-floating-details__image {
  height: 90px;
  margin: -0.5rem auto 0.5rem;
  -o-object-fit: scale-down;
  object-fit: scale-down;
  -o-object-position: center;
  object-position: center;
  pointer-events: none;
}

.item-floating-details__top {
  width: 100%;
}

.item-floating-details__main {
  display: flex;
  flex-direction: column;
  position: relative;
}

.item-details-paint {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.item-details-box {
  background-color: rgb(253, 246, 236);
  border-radius: 0.25rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .05);
  font-size: .75rem;
  padding: 1rem;
}

.item-float {
  background-color: var(--float-background-color);
  display: flex;
  height: 4px;
  pointer-events: none;
  position: relative;
  width: 100%;
  z-index: 1;
  margin-bottom: 8px;
}

.item-float.large {
  margin-top: 4px;
}

.item-float.large .item-float.large .item-float__bar {
  border-radius: 2px;
  height: 6px;
}

.item-floating-details {
  margin: 8px;
  position: relative;
}

.item-float__bar {
  background: linear-gradient(90deg, #3b818f 0, #3b818f 7%, #83b135 0, #83b135 15%, #d7be47 0, #d7be47 38%, #f08140 0, #f08140 45%, #ec4f3d 0, #ec4f3d);
  -webkit-clip-path: polygon(var(--float-range-start) 0, var(--float-range-end) 0, var(--float-range-end) 100%, var(--float-range-start) 100%);
  clip-path: polygon(var(--float-range-start) 0, var(--float-range-end) 0, var(--float-range-end) 100%, var(--float-range-start) 100%);
  height: 4px;
  transition: opacity 275ms;
  width: 100%;
}

.item-details-row {
  display: flex;
  font-size: .875rem;
  justify-content: space-between;
}

.item-float__indicator {
  fill: deepskyblue;
  bottom: 4px;
  display: none;
  position: absolute;
  transition: opacity 275ms;
}

.item-float.large .item-float__indicator {
  display: block;
}

.item-floating-730-label {
  font-size: 12px;
  height: 54px;
  text-align: center;
}

.base-clipboard:hover {
  cursor: pointer;
}

.item-details-row-light {
  display: flex;
  height: 28px;
  text-align: left;
  font-size: 12px;
  align-items: center;
}

.item-float__indicator {
  fill: #fff;
  bottom: 4px;
  display: none;
  left: -10px;
  margin-left: var(--float-value);
  position: absolute;
  transition: opacity 275ms;
}

.item-float__bar {
  background: linear-gradient(90deg, #3b818f 0, #3b818f 7%, #83b135 0, #83b135 15%, #d7be47 0, #d7be47 38%, #f08140 0, #f08140 45%, #ec4f3d 0, #ec4f3d);
  -webkit-clip-path: polygon(var(--float-range-start) 0, var(--float-range-end) 0, var(--float-range-end) 100%, var(--float-range-start) 100%);
  clip-path: polygon(var(--float-range-start) 0, var(--float-range-end) 0, var(--float-range-end) 100%, var(--float-range-start) 100%);
  height: 4px;
  transition: opacity 275ms;
  width: 100%;
}

.item-float:after {
  background-color: #fff;
  bottom: 0;
  content: "";
  height: 6px;
  left: min(var(--float-value), 100% - 1px);
  position: absolute;
  transition: opacity 275ms;
  width: 1px;
}

/deep/ .el-autocomplete-suggestion el-popper {
  width: auto;
  min-width: 235px;
}

/deep/ .el-tabs--border-card > .el-tabs__header {
  border: none;
}

/deep/ .el-tabs--border-card > .el-tabs__content {
  padding: 0;
}

.tradeUpTemplate {
  padding: 0 12px;
}

/deep/ .el-dialog--center .el-dialog__body {
  padding: 0 20px;
}

.tradeUpHistory {
  display: inline-flex;
  color: #c0c4cc;
  margin-left: 12px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  position: relative;
  outline: none;
  cursor: pointer;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
}

.tradeUpHistory:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/ui/TradeUp/index.vue